// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink_link__pE1cG","active":"SidebarLink_active__ZW+PL"};